import { z } from 'zod'
import { widgetSchema, widgetFilterSchema } from '../../common/schema'
import { explorerColorSchema, explorerLightColors, explorerDarkColors } from '../../common/card-colors'

export const propertyMapFilterSchema = widgetFilterSchema.extend({
  feed_id: z.number().int().describe('Feed ID'),
  platform: z.string().nullish().describe('Platform UUID'),
  property: z.string().describe('Property slug'),
})

export type PropertyMapFilter = z.infer<typeof propertyMapFilterSchema>

export const propertyMapWidgetConfig = widgetSchema.extend({
  section: z.object({
    show: z.boolean().default(false).describe('Show the section title above the widget content'),
    title: z.string().nullish().default('Location').describe('Section title text'),
  }).default({ show: false, title: 'Location' }).describe('Section heading shown above the widget content'),
  height: z.number().default(350).describe('Map height in pixels'),
  zoom: z.number().int().min(1).max(18).default(14).describe('Default zoom level'),
  showPrice: z.boolean().default(true).describe('Show price on marker badge'),
  // Deprecated (#692): never read by render code. Kept so stored blobs still parse. Superseded by tooltipOnLoad.
  showTooltipOnLoad: z.boolean().default(true).describe('Automatically show tooltip on map load'),
  tooltipOnLoad: z.boolean().default(false).describe('Automatically show the marker tooltip when the map loads'),
  filter: propertyMapFilterSchema,
  lightModeColors: explorerColorSchema(explorerLightColors).default(explorerLightColors).describe('Colors in light mode'),
  darkModeColors: explorerColorSchema(explorerDarkColors).default(explorerDarkColors).describe('Colors in dark mode'),
})

export type PropertyMapWidgetConfig = z.infer<typeof propertyMapWidgetConfig>
